import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import Moment from 'moment';
import flatpickr from 'flatpickr'; // Add more locales here

import { Mandarin as zh } from 'flatpickr/dist/l10n/zh'; // material ui component

import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { wire } from './hoc/prop-wire';
import ih from './utils/input-helper';
import { flatpickrToMomentToken } from './utils/date';
import Popover from './popover';
import { SIMPLE_VALUE_PROP } from './consts/prop-types';
var DATE_PROP_TYPE = PropTypes.shape({
  from: SIMPLE_VALUE_PROP,
  to: SIMPLE_VALUE_PROP
});
var DATE_TIME_SUFFIX = {
  daySuffix: /(st)|(nd)|(rd)|(th)/g,
  timeSuffix: /(AM)|(PM)/gi
};
/**
 * A React DateRange Component, containing a 'from' date input and a 'to' date input<br>
 * Uses [flatpickr]{@link https://chmln.github.io/flatpickr/#options}
 *
 * @constructor
 * @param {string} [id] - Container element #id
 * @param {string} [className] - Classname for the container
 * @param {object} [defaultValue] - Default selected range
 * @param {string} defaultValue.from - Default selected from
 * @param {string} defaultValue.to - Default selected to
 * @param {object} [value] - Current selected range
 * @param {string} value.from - Current selected from
 * @param {string} value.to - Current selected to
 * @param {object} [valueLink] - Link to update value. Used in conjuction with [linked-state-mixins]{@link module:linked-state-mixins}
 * @param {*} valueLink.value - value to update
 * @param {function} valueLink.requestChange - function to request value change
 * @param {boolean} [allowKeyIn=true] - Allow user key in to the from/to input?
 * @param {boolean} [disabled=false] - Is this field disabled?
 * @param {boolean} [readOnly=false] - Is this field readonly?
 * @param {boolean} [required=false] - Is this field required?
 * @param {function} [onChange] - Callback function when from/to is changed. <br> Required when value prop is supplied
 * @param {function} [onClose] - Callback function when flatpickr from/to is close
 * @param {object} onChange.value - current value
 * @param {string} onChange.value.from - current from
 * @param {string} onChange.value.to - current to
 * @param {object} onChange.eventInfo - event related info
 * @param {object} onChange.eventInfo.before - previously enetered value
 * @param {string} [dateFormat='Y-m-d'] - Date format. See Flatpickr {@link https://chmln.github.io/flatpickr/#options}
 * @param {string} [timeFormat='H:i'] - Time format. See Flatpickr {@link https://chmln.github.io/flatpickr/#options}
 * @param {boolean} [enableTime=false] - Enable selection and display of time
 * @param {boolean} [enableAMPM=false] - Enable AM/PM option on calendar
 * @param {string} [locale] - Datepicker locale. Values can be 'en', 'zh', etc. See Flatpickr {@link https://chmln.github.io/flatpickr/#options}
 * @param {fuction} [t] - Transform/translate error into readable message.<br>
 * @param {object} t.params - Parameters relevant to the error code
 * @param {string} t.params.field - offending field id
 * @param {string} t.params.value - offending field value
 * @param {string} t.params.pattern - pattern the value was supposed to follow
 * @param {bollean} enableStartEndLabel - Enable start time and end time label
 * @param {string} startLabel - It's start time label
 * @param {string} endLabel - It's end time label
 * @param {string} limitRange - It use to limit start and end time range. (format: [1~n]d[1~n]h[1~n]m[1~n]s)
 *
 * @example
// controlled

import {DateRange} from 'react-ui'

React.createClass({
    getInitialState() {
        return {
            date:{
                from:'2012-04-26',
                to:'2012-10-26'
            },
            datetime:{
                from:'2012-10-26 12:00',
                to:'2012-10-26 17:00'
            }
        }
    },
    handleChange(field, value) {
        this.setState({[field]:value})
    },
    render() {
        let {date, datetime} = this.state;
        return <div className='c-form'>
            <div>
                <label htmlFor='date'>Select Date Range</label>
                <DateRange id='date'
                    onChange={this.handleChange.bind(this,'date')}
                    value={date}
                    t={(code, params) => {
                        if (code === 'missing')
                            return `Please input date`
                        else {
                            return `Invalid date format. Should be ${params.pattern}`
                        }
                    }}/>
            </div>
            <div>
                <label htmlFor='datetime'>Select Date Time Range</label>
                <DateRange id='datetime'
                    onChange={this.handleChange.bind(this,'datetime')}
                    enableTime={true}
                    value={datetime}
                    t={(code, params) => {
                        if (code === 'missing')
                            return `Please input date`
                        else {
                            return `Invalid date format. Should be ${params.pattern}`
                        }
                    }}/>
            </div>
        </div>
    }
})
 */

var DateRange = /*#__PURE__*/function (_React$Component) {
  _inherits(DateRange, _React$Component);

  var _super = _createSuper(DateRange);

  function DateRange(props) {
    var _this;

    _classCallCheck(this, DateRange);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "limitTimeRange", function (r) {
      // 1s = 1000, 1m = 60000, 1h = 3600000, 1d = 86400000
      var rg = r;
      var count = {
        d: 24 * 60 * 60 * 1000,
        h: 60 * 60 * 1000,
        m: 60 * 1000,
        s: 1 * 1000
      };
      var result = 0;

      for (var unit in count) {
        if (r.indexOf(unit) === -1) continue;
        var ary = rg.split(unit);
        var val = Number(ary[0]);
        rg = ary[1];
        result = result + val * count[unit];
      }

      return result;
    });

    _defineProperty(_assertThisInitialized(_this), "checkCross", function (type) {
      var _this$props = _this.props,
          limitRange = _this$props.limitRange,
          _this$props$value = _this$props.value,
          from = _this$props$value.from,
          to = _this$props$value.to;

      var dateFrom = _this.strToTimestamp(_this.dateFrom.value ? _this.dateFrom.value : from),
          dateTo = _this.strToTimestamp(_this.dateTo.value ? _this.dateTo.value : to);

      if (dateFrom !== dateTo) {
        if (type === 'from') {
          // handle from time
          var isAfter = Moment(dateFrom).isAfter(dateTo);

          if (isAfter) {
            _this.datePicker.to.setDate(dateFrom, false);

            _this.handleChange();
          }

          if (limitRange) {
            var limitValue = _this.limitTimeRange(limitRange);

            if (dateFrom + limitValue < dateTo) {
              _this.datePicker.to.setDate(dateFrom + limitValue, false);

              _this.handleChange();
            }
          }
        } else {
          // handle to time
          var isBefore = Moment(dateTo).isBefore(dateFrom);

          if (isBefore) {
            _this.datePicker.from.setDate(dateTo, false);

            _this.handleChange();
          }

          if (limitRange) {
            var _limitValue = _this.limitTimeRange(limitRange);

            if (dateTo - _limitValue > dateFrom) {
              _this.datePicker.from.setDate(dateTo - _limitValue, false);

              _this.handleChange();
            }
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "generateErrorMsg", function (type, dateStr) {
      var _this$props2 = _this.props,
          id = _this$props2.id,
          enableTime = _this$props2.enableTime,
          required = _this$props2.required,
          t = _this$props2.t;
      var datePattern = _this.FORMAT.date,
          timePattern = _this.FORMAT.time.indexOf('A') !== -1 ? _this.FORMAT.time.replace('A', 'AM/PM') : _this.FORMAT.time;
      var pattern = enableTime ? "".concat(datePattern, " ").concat(timePattern) : datePattern;
      return ih.validateField(dateStr, {
        name: "".concat(id, "-").concat(type),
        type: 'date',
        required: required,
        pattern: pattern
      }, t ? {
        et: t
      } : true);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (type, evt) {
      Popover.closeId("err-".concat(type));
      var newDate = evt.target.value;

      var isValid = _this.validateDateFormat(newDate);

      var field = type === 'from' ? 'prevFrom' : 'prevTo';
      var prevDate = type === 'from' ? _this.state.prevFrom : _this.state.prevTo;
      var required = _this.props.required;

      if (isValid) {
        // Prevent requiring double-click when select date
        if (newDate !== prevDate) {
          _this.datePicker[type].setDate(newDate);

          _this.setState(_defineProperty({}, field, newDate));
        }

        _this.checkCross(type);
      } else {
        // Reset to previous valid value
        if (required) {
          _this.datePicker[type].setDate(prevDate);
        } else {
          _this.datePicker[type].setDate('');

          _this.handleChange();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          _this$props3$value = _this$props3.value,
          from = _this$props3$value.from,
          to = _this$props3$value.to;
      onChange({
        from: _this.dateFrom.value ? _this.dateFrom.value : from,
        to: _this.dateTo.value ? _this.dateTo.value : to
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (type, evt) {
      var required = _this.props.required;
      var newDate = evt.target.value; // Remove the day suffix since Date can't resolve it

      var parseDate = _this.strToTimestamp(newDate);

      var isValid = _this.validateDateFormat(newDate);

      var errMsg = _this.generateErrorMsg(type, newDate);

      if (!isNaN(parseDate)) {
        // Move the calendar view to the current value's location
        _this.datePicker[type].jumpToDate(parseDate);

        if (isValid) {
          Popover.closeId("err-".concat(type)); // setDate() accepts date string & Date object
          // If set the 2nd parameter as true, it will recursively call itself here

          _this.datePicker[type].setDate(parseDate, false);

          _this.handleChange();

          _this.checkCross(type);
        } else {
          Popover.openId("err-".concat(type), evt, /*#__PURE__*/React.createElement("span", null, errMsg), {
            pointy: true
          });
        }
      } else {
        if (required || newDate !== '') {
          Popover.openId("err-".concat(type), evt, /*#__PURE__*/React.createElement("span", null, errMsg), {
            pointy: true
          });
        } else {
          Popover.closeId("err-".concat(type));
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "strToTimestamp", function (str) {
      var enableTime = _this.props.enableTime;
      var parsedStr = str.replace(DATE_TIME_SUFFIX.daySuffix, '');
      var momentFormat = enableTime ? "".concat(_this.FORMAT.date, " ").concat(_this.FORMAT.time) : _this.FORMAT.date;
      return Moment(parsedStr, momentFormat).valueOf();
    });

    _defineProperty(_assertThisInitialized(_this), "validateDateFormat", function (dateStr) {
      var enableTime = _this.props.enableTime;
      var isValid = false;

      if (enableTime) {
        isValid = Moment(dateStr, "".concat(_this.FORMAT.date, " ").concat(_this.FORMAT.time), true).isValid(); // Momentjs validation accepts single (a|A|p|P) for AM/PM
        // This is for ensuring user input complete 'AM/PM' term when AM/PM is enabled

        if (_this.FORMAT.time.indexOf('A') !== -1 && dateStr.search(DATE_TIME_SUFFIX.timeSuffix) === -1) {
          isValid = false;
        }
      } else {
        isValid = Moment(dateStr, "".concat(_this.FORMAT.date), true).isValid();
      }

      return isValid;
    });

    var value = props.value;
    _this.state = {
      prevFrom: value.from,
      prevTo: value.to
    };
    return _this;
  }

  _createClass(DateRange, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props4 = this.props,
          dateFormat = _this$props4.dateFormat,
          timeFormat = _this$props4.timeFormat,
          enableTime = _this$props4.enableTime,
          enableAMPM = _this$props4.enableAMPM,
          allowInput = _this$props4.allowKeyIn,
          locale = _this$props4.locale,
          _onClose = _this$props4.onClose;
      var loc = null;

      switch (locale) {
        case 'zh':
          loc = zh;
          break;

        default:
          loc = null;
      }

      this.FORMAT = flatpickrToMomentToken(dateFormat, timeFormat, enableTime);

      if (enableTime) {
        dateFormat = dateFormat + ' ' + timeFormat;
      }

      this.datePicker = {
        from: flatpickr(this.dateFrom, {
          enableTime: enableTime,
          allowInput: allowInput,
          dateFormat: dateFormat,
          locale: loc,
          time_24hr: !enableAMPM,
          onChange: function onChange() {
            _this2.checkCross('from');

            _this2.handleChange();
          },
          onClose: function onClose() {
            if (_onClose) _onClose({
              from: _this2.dateFrom.value,
              to: _this2.dateTo.value
            });
          }
        }),
        to: flatpickr(this.dateTo, {
          enableTime: enableTime,
          allowInput: allowInput,
          dateFormat: dateFormat,
          locale: loc,
          time_24hr: !enableAMPM,
          onChange: function onChange() {
            _this2.checkCross('to');

            _this2.handleChange();
          },
          onClose: function onClose() {
            if (_onClose) _onClose({
              from: _this2.dateFrom.value,
              to: _this2.dateTo.value
            });
          }
        })
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.datePicker.from.destroy();
      this.datePicker.to.destroy();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var value = nextProps.value,
          locale = nextProps.locale;
      var loc = null;

      switch (locale) {
        case 'zh':
          loc = zh;
          break;

        default:
          loc = null;
      }

      this.datePicker.from.set('locale', loc);
      this.datePicker.to.set('locale', loc);
      this.datePicker.from.setDate(this.strToTimestamp(value.from), false);
      this.datePicker.to.setDate(this.strToTimestamp(value.to), false);
      this.setState({
        prevFrom: value.from,
        prevTo: value.to
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props5 = this.props,
          id = _this$props5.id,
          value = _this$props5.value,
          className = _this$props5.className,
          readOnly = _this$props5.readOnly,
          disabled = _this$props5.disabled,
          required = _this$props5.required,
          allowKeyIn = _this$props5.allowKeyIn,
          autoComplete = _this$props5.autoComplete,
          enableStartEndLabel = _this$props5.enableStartEndLabel,
          startLabel = _this$props5.startLabel,
          endLabel = _this$props5.endLabel;
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: cx('c-date-range', className)
      }, enableStartEndLabel && /*#__PURE__*/React.createElement("span", {
        className: "date-range-label startLabel"
      }, startLabel), /*#__PURE__*/React.createElement("span", {
        className: "c-date-picker"
      }, /*#__PURE__*/React.createElement(TextField, {
        id: id + '-from',
        type: "text",
        error: !value.from && required,
        inputRef: function inputRef(ref) {
          _this3.dateFrom = ref;
        },
        disabled: disabled,
        fullWidth: true,
        readOnly: readOnly,
        required: required,
        onChange: allowKeyIn ? this.handleInputChange.bind(this, 'from') : null,
        onBlur: this.handleBlur.bind(this, 'from'),
        defaultValue: value.from,
        autoComplete: autoComplete,
        variant: "outlined",
        size: "small",
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
            position: "end"
          }, /*#__PURE__*/React.createElement(DateRangeIcon, {
            className: "date-range-icon",
            fontSize: "small",
            onClick: function onClick() {
              _this3.dateFrom.focus();
            }
          }))
        }
      })), !enableStartEndLabel ? /*#__PURE__*/React.createElement("span", {
        className: "between"
      }, "~") : /*#__PURE__*/React.createElement("span", {
        className: "date-range-label endlabel"
      }, endLabel), /*#__PURE__*/React.createElement("span", {
        className: "c-date-picker"
      }, /*#__PURE__*/React.createElement(TextField, {
        id: id + '-to',
        type: "text",
        error: !value.to && required,
        inputRef: function inputRef(ref) {
          _this3.dateTo = ref;
        },
        disabled: disabled,
        fullWidth: true,
        readOnly: readOnly,
        required: required,
        onChange: allowKeyIn ? this.handleInputChange.bind(this, 'to') : null,
        onBlur: this.handleBlur.bind(this, 'to'),
        defaultValue: value.to,
        autoComplete: autoComplete,
        variant: "outlined",
        size: "small",
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
            position: "end"
          }, /*#__PURE__*/React.createElement(DateRangeIcon, {
            className: "date-range-icon",
            fontSize: "small",
            onClick: function onClick() {
              _this3.dateTo.focus();
            }
          }))
        }
      })));
    }
  }]);

  return DateRange;
}(React.Component);

_defineProperty(DateRange, "defaultProps", {
  dateFormat: 'Y-m-d',
  timeFormat: 'H:i',
  disabled: false,
  readOnly: false,
  required: false,
  allowKeyIn: true,
  enableTime: false,
  enableAMPM: false,
  locale: 'en',
  autoComplete: 'off',
  enableStartEndLabel: false,
  limitRange: null
});

_defineProperty(DateRange, "propTypes", {
  id: PropTypes.string,
  className: PropTypes.string,
  value: DATE_PROP_TYPE,
  allowKeyIn: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  dateFormat: PropTypes.string,
  timeFormat: PropTypes.string,
  enableTime: PropTypes.bool,
  enableAMPM: PropTypes.bool,
  locale: PropTypes.string,
  autoComplete: PropTypes.string,
  t: PropTypes.func,
  enableStartEndLabel: PropTypes.bool,
  startLabel: PropTypes.string,
  endLabel: PropTypes.string,
  limitRange: PropTypes.string
});

export default wire(DateRange, 'value', {});